export default {
    STORE_PARENT: 'store-parent',
    TICKET_PARENT: 'ticket-parent',
}